import { useEffect, useState } from 'react';

/**
 * Suit une media query CSS — utilisé pour la coquille des onglets de projet (§2.3/§6.4 :
 * la rangée déborde sous 720 px, se regroupe dans un menu « Plus »).
 *
 * @param {string} query
 * @returns {boolean}
 */
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mql = window.matchMedia(query);
    setMatches(mql.matches);
    const onChange = (event) => setMatches(event.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
